import React from 'react';

const Clients = () => {
  const clients = [
    {
      name: 'Agent Group Realty',
      logo: 'https://customer-assets.emergentagent.com/job_clipcraft-270/artifacts/s8ypcufo_470208264_1234552051497718_3392927965333365358_n.jpg',
      tintWhite: false
    },
    {
      name: 'McLaurin Law, LLC',
      logo: 'https://customer-assets.emergentagent.com/job_clipcraft-270/artifacts/nudc96i4_300x300-01-1.png',
      tintWhite: false
    },
    {
      name: 'Keowee Key',
      logo: 'https://customer-assets.emergentagent.com/job_clipcraft-270/artifacts/fy506jn3_keowee%20key.png',
      tintWhite: false
    },
    {
      name: 'The Go-To Group',
      logo: 'https://customer-assets.emergentagent.com/job_clipcraft-270/artifacts/813zm2o2_The_Go-To_Group_Logo.png',
      tintWhite: true
    },
    {
      name: 'Austin Mauldin',
      logo: 'https://customer-assets.emergentagent.com/job_clipcraft-270/artifacts/bll62j4c_Austim%20logo%20sample.png',
      tintWhite: false
    },
    {
      name: 'New Story Kendig',
      logo: 'https://customer-assets.emergentagent.com/job_clipcraft-270/artifacts/er96azcz_new%20story%20kendig.png',
      tintWhite: true
    },
    {
      name: 'Cross Creek',
      logo: 'https://customer-assets.emergentagent.com/job_clipcraft-270/artifacts/boahit6g_cross_creak_logo-removebg-preview%20%281%29.png',
      tintWhite: true
    },
    {
      name: 'Rock the Ranch',
      logo: 'https://customer-assets.emergentagent.com/job_clipcraft-270/artifacts/w53tf8m8_rock%20the%20ranch%20logo.webp',
      tintWhite: true
    },
    {
      name: 'Sip and Swing',
      logo: 'https://customer-assets.emergentagent.com/job_clipcraft-270/artifacts/ccq6olxz_sip%20and%20swing%20logo.png',
      tintWhite: false
    },
    {
      name: 'Lighthouse Lake Keowee',
      logo: 'https://customer-assets.emergentagent.com/job_clipcraft-270/artifacts/2asb7h3j_the%20light%20house%20lake%20keowee.png',
      tintWhite: false
    },
    {
      name: 'Two Horse Distillery',
      logo: 'https://customer-assets.emergentagent.com/job_clipcraft-270/artifacts/ljxy5gml_two%20horse%20distillery.jpg',
      tintWhite: false
    },
    {
      name: 'The Reserve at Lake Keowee',
      logo: 'https://customer-assets.emergentagent.com/job_clipcraft-270/artifacts/57sshrrr_reserve-logo.png',
      tintWhite: false
    }
  ];

  // Duplicate the clients array for seamless infinite scroll
  const duplicatedClients = [...clients, ...clients];

  return (
    <section className="py-20 md:py-24 bg-[#050505] border-t border-white/5 overflow-hidden" data-testid="clients-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <p className="overline mb-5">Trusted By</p>
          <h2 className="text-3xl md:text-4xl font-semibold text-white">
            Partnering with <span className="gold-gradient">industry leaders</span>
          </h2>
        </div>

        {/* Scrolling Logo Container */}
        <div className="relative">
          {/* Gradient Overlays */}
          <div className="absolute left-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-r from-[#050505] to-transparent z-10"></div>
          <div className="absolute right-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-l from-[#050505] to-transparent z-10"></div>
          
          {/* Scrolling Content */}
          <div className="logo-scroll-container">
            <div className="logo-scroll-content">
              {duplicatedClients.map((client, index) => (
                <div
                  key={index}
                  className="logo-item group flex items-center justify-center p-6 bg-white/[0.03] rounded-xl border border-white/5 hover:border-[#d4af37]/40 transition-all duration-300"
                >
                  <img
                    src={client.logo}
                    alt={client.name}
                    className={`max-w-full max-h-full object-contain opacity-60 group-hover:opacity-100 transition-all duration-500 ${
                      client.tintWhite ? 'brightness-0 invert' : ''
                    }`}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clients;
